<template>
    <div v-if="treatment" class="patient-share-treatment">
        <patient-share-header @logout="logout" />
        <embryo-previews :embryos="treatment.wells" />

        <!-- key provides component re-render when another well is chosen -->
        <selected-embryo v-if="selectedEmbryoId" :key="selectedEmbryoId" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import PatientShareHeader from '../../components/patient-share/PatientShareHeader'
import EmbryoPreviews from '../../components/patient-share/EmbryoPreviews'
import SelectedEmbryo from '../../components/patient-share/SelectedEmbryo'
import UIUtils from '../../../business/utils/UIUtils'
import BackendProvider from '../../../business/services/BackendProvider'

export default {
    name: 'PatientShareTreatment',
    components: { SelectedEmbryo, PatientShareHeader, EmbryoPreviews },
    data: () => ({
        auth0: null
    }),
    computed: {
        ...mapState({
            treatment: state => state.patient.treatment,
            selectedEmbryoId: state => state.patient.selectedEmbryoId,
            birthYear: state => state.patient.birthYear
        }),
        isAuthenticated() {
            return this.$auth0.isAuthenticated
        },
        authError() {
            return this.$auth0.error
        }
    },
    async mounted() {
        if (this.isAuthenticated) {
            await this.fetchTreatment()
            this.setSelectedEmbryo()
        } else {
            await this.moveToPatientWelcomeScreen()
        }
        zE('webWidget', 'hide')
    },
    methods: {
        async fetchTreatment() {
            const { cipher } = this.$route.query
            if (!this.treatment && cipher) {
                UIUtils.showLoadingMask()
                try {
                    const token = await this.$auth0.getIdToken()
                    const treatment = await BackendProvider.getSharedToPatientTreatment(
                        {
                            cipher: encodeURIComponent(cipher),
                            birthYear: this.birthYear
                        },
                        token
                    )
                    this.$store.commit('patient/treatment', treatment)
                } catch (e) {
                    this.error = 'The year rof birth is incorrect, try again.'
                    await this.logout()
                } finally {
                    UIUtils.hideLoadingMask()
                }
            }
        },
        setSelectedEmbryo() {
            const { embryo: embryoIdFromURL } = this.$route.query

            if (embryoIdFromURL && embryoIdFromURL !== this.selectedEmbryoId) {
                this.$store.commit('patient/selectedEmbryoId', embryoIdFromURL)
            } else {
                const { _id } = this.treatment.wells[0]

                this.$router.push({ query: { ...this.$route.query, embryo: _id } })
                this.$store.commit('patient/selectedEmbryoId', _id)
            }
        },
        async logout() {
            await this.$auth0.logout({ returnTo: window.location.href.replace('/treatment', '') })
        },
        moveToPatientWelcomeScreen() {
            return this.$router.push({
                path: '/patient-share',
                query: this.$route.query
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.patient-share-treatment {
    position: relative;
    height: 100%;
    overflow: auto;
    display: grid;
    @include hide-scrollbar();

    .patient-share-header {
        grid-area: header;
    }
    .embryo-previews {
        grid-area: previews;
    }
    .selected-embryo {
        grid-area: selected;
    }

    @media screen and #{$new-break2close} {
        grid-template-rows: repeat(3, min-content);
        grid-template-areas:
            'header'
            'previews'
            'selected';

        .embryo-previews {
            width: 100%;
        }
    }

    @media screen and #{$new-break3open} {
        column-gap: 10px;
        grid-template-columns: 1fr 2fr;
        grid-template-areas:
            'header   header'
            'previews selected';

        .embryo-previews {
            max-width: 370px;
            justify-self: center;
        }
        .selected-embryo {
            max-width: 690px;
            justify-self: start;
        }
    }
}
</style>
